export default (editorState) => {
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    return blocks ? blocks.size : 0;
};
